import { useState, useEffect, useCallback } from 'react';

/**
 * Hook customizado para auto-refresh de dados
 * @param {Function} fetchFunction - Função que busca os dados
 * @param {number} interval - Intervalo em ms (default: 30000 = 30s)
 * @returns {Object} { isEnabled, setIsEnabled, lastUpdate, isLoading, refresh }
 */
export const useAutoRefresh = (fetchFunction, interval = 30000) => {
  const [isEnabled, setIsEnabled] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(new Date().toLocaleTimeString());
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    setIsLoading(true);
    try {
      await fetchFunction();
      setLastUpdate(new Date().toLocaleTimeString());
    } catch (error) {
      console.error('Auto-refresh error:', error);
    } finally {
      setIsLoading(false);
    }
  }, [fetchFunction]);

  useEffect(() => {
    if (!isEnabled) return;

    const intervalId = setInterval(refresh, interval);
    return () => clearInterval(intervalId);
  }, [isEnabled, interval, refresh]);

  return {
    isEnabled,
    setIsEnabled,
    lastUpdate,
    isLoading,
    refresh,
  };
};
